import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import VueMask from 'v-mask'
import DatePicker from './components/DatePicker.vue'

Vue.use(VueMask);
Vue.use(require('vue-moment'));
Vue.component('DatePicker', DatePicker);
Vue.config.productionTip = false

// Add Strict-Transport-Security header
const metaHSTS = document.createElement('meta');
metaHSTS.httpEquiv = 'Strict-Transport-Security';
metaHSTS.content = 'max-age=31536000; includeSubDomains; preload';
document.getElementsByTagName('head')[0].appendChild(metaHSTS);

// Add Content-Security-Policy header
const metaCSP = document.createElement('meta');
metaCSP.httpEquiv = 'Content-Security-Policy';
metaCSP.content = "default-src 'self'; form-action 'self'; object-src 'none'; frame-ancestors 'none'; upgrade-insecure-requests; block-all-mixed-content; style-src 'self' 'unsafe-inline'; img-src 'self' data: blob:; script-src 'self' 'nonce-randomNonceGoesHere'; base-uri 'self';";
document.getElementsByTagName('head')[0].appendChild(metaCSP);

// Add X-Frame-Options header
const metaXFO = document.createElement('meta');
metaXFO.httpEquiv = 'X-Frame-Options';
metaXFO.content = 'deny';
document.getElementsByTagName('head')[0].appendChild(metaXFO);

// Add Access-Control-Allow-Origin header
const metaACAO = document.createElement('meta');
metaACAO.httpEquiv = 'Access-Control-Allow-Origin';
metaACAO.content = '*';
document.getElementsByTagName('head')[0].appendChild(metaACAO);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
